import React from "react";
import { ToastContainer } from "react-toastify";
import classes from "../../style/Style.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";

const DeactivatedScreen = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const { reason } = location.state || {};
  console.log(reason);
  const HandleBack = () => {
    Navigate(-1);
  };
  const HandleSubmit = () => {
    // Navigate(ROUTE_BLANK_TEXT_SCREEN);
  };
  return (
    <div className={classes.Pan_Main_Container}>
      <div className={classes.Header}>
        <ArrowBackIosIcon className={classes.Back_btn} onClick={HandleBack} />
      </div>
     
        <p className={classes.Input_Heading_text}>
            {reason} 
        </p>
        {/* <button className={classes.Submit_button} onClick={HandleSubmit}>
        Proceed
      </button> */}
      <ToastContainer />
    </div>
  );
};


export default DeactivatedScreen;